import Vue from 'vue'
import autowidth from '@/directives/autowidth'
import resize from '@/directives/resize'

Vue.directive('autowidth', autowidth)
Vue.directive('element-resize', resize)
